import React, { useState, useEffect, useRef } from "react";
import { IDropdownComponentProps } from "../types";

const Dropdown: React.FC<IDropdownComponentProps> = ({
  children,
  className,
  menu,
  type = "click",
  position = "top-0 left-full",
  disabled,
}) => {
  const [open, setOpen] = useState(false);
  const compRef = useRef<HTMLDivElement>(null);

  const handleOuterClick = (event: MouseEvent) => {
    if (compRef.current && !compRef.current.contains(event.target as Node)) {
      setOpen(false);
    }
  };

  const clickAndCloseHandler: (func: () => void) => any = (func) => {
    return () => {
      func();
      setOpen(false);
    };
  };

  useEffect(() => {
    if (type === "click") {
      if (open) {
        document.addEventListener("click", handleOuterClick);
        return () => {
          document.removeEventListener("click", handleOuterClick);
        };
      }
    }
  }, [open]);

  return (
    <div
      ref={compRef}
      className="relative"
      onMouseLeave={() => {
        if (type === "hover") {
          setOpen(false);
        }
      }}
    >
      <span
        onClick={() => {
          if (type === "click" && !disabled) {
            setOpen(!open);
          }
        }}
        onMouseEnter={() => {
          if (type === "hover") {
            setOpen(true);
          }
        }}
      >
        {children}
      </span>
      {open && (
        <div
          className={`absolute bg-white rounded-md shadow-lg mb-2 ${className} ${position}`}
          style={{ minWidth: "190px", zIndex: 2000, width: "max-content" }} // Z-index is 71 because the Blockly workspace has a z-index of 70
        >
          {React.cloneElement(menu, { clickAndCloseHandler })}
        </div>
      )}
    </div>
  );
};

export { Dropdown };
